module.exports = __webpack_public_path__ + "img/login.bdf63122.png";